import React from "react";

import { StatusBadgeProps } from "./statusBadgeProps";

export const VoidStatusBadge = (props: StatusBadgeProps) => {
    const { width, height = "18", viewBox = "0 0 34.4 18", ...rest } = props;

    return (
        <svg
            width={width}
            height={height}
            viewBox={viewBox}
            {...rest}
            enableBackground="enable-background:new 0 0 141.8 18;"
            xmlSpace="preserve"
        >
            <path
                fill="#FE6967"
                fillRule="evenodd"
                d="M32.7 18h-31c-1 0-1.7-.7-1.7-1.7V1.7C0 .7.7 0 1.7 0h31c.9 0 1.7.7 1.7 1.7v14.7c0 .9-.8 1.6-1.7 1.6z"
            ></path>
            <g>
                <g transform="translate(-957 -10126)">
                    <path
                        fill="#FE6967"
                        fillRule="evenodd"
                        d="M37 24.8H1c-.5 0-1 .9-1 2v14c0 1.1.4 2 1 2h36c.5 0 1-.9 1-2v-14c0-1.1-.4-2-1-2z"
                        transform="translate(957 10126)"
                    ></path>
                </g>
            </g>
            <g fill="#FFF">
                <path d="M10.8 4.6L7.5 13H6.4L3 4.6h1.7L7 10.5l2.2-5.9h1.6zM11 8.8c0-2.6 1.6-4.4 4-4.4s4 1.7 4 4.4c0 2.6-1.6 4.4-4 4.4-2.3 0-4-1.8-4-4.4zm6.5 0c0-1.8-1-2.9-2.5-2.9S12.5 7 12.5 8.8c0 1.8 1 2.9 2.5 2.9 1.6.1 2.5-1.1 2.5-2.9zM20.6 4.6H22V13h-1.5V4.6zM24.2 4.6h2.4c2.8 0 4.4 1.5 4.4 4.2s-1.5 4.1-4.4 4.1h-2.4V4.6zm2.2 7c2.1 0 3-.8 3-2.8 0-1.9-.9-2.8-2.9-2.8h-.9v5.6h.8z"></path>
            </g>
        </svg>
    );
};
